import styled, { css } from 'styled-components';
import { FlexCenterAligned } from '../../../../../styled/common';
import { tagStyles } from '../../../../ui/Typography/styles';
import { Breakpoints } from '../../../../../styled/constants';
import { CheckboxMark, CheckboxLabel } from '../../../../ui/Checkbox/styled';

export const PricePlaceholder = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ManatIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
`;

export const CheckBoxesContainer = styled(FlexCenterAligned)`
  gap: 20px;
  align-items: flex-start;

  @media (max-width: ${Breakpoints.smallDesktop - 1}px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
`;

export const CheckboxesRow = styled(FlexCenterAligned)`
  gap: 20px;

  @media (max-width: ${Breakpoints.tablet - 1}px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
`;

export const CheckBoxWrapper = styled.div<{ $disabled?: boolean }>`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 14px;
  padding: 4px 15px;
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;

      && ${CheckboxLabel} {
        color: ${({ theme }) => theme.colors.text.tertiary};
      }

      && ${CheckboxMark} {
        background-color: rgba(66, 100, 253, 0.3);
        border-color: rgba(66, 100, 253, 0.3);
      }
    `}
`;

export const MortgageFieldWrapper = styled.div`
  flex: 1;
  position: relative;
`;

export const RemainTermContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const RemainTermLabel = styled.span`
  ${tagStyles.title_4_new}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const RemainTermRow = styled(FlexCenterAligned)`
  gap: 20px;
  align-items: flex-start;
`;

export const PercentSuffix = styled.span`
  position: absolute;
  right: 16px;
  top: 30px;
  pointer-events: none;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  z-index: 3;
`;
